import { Link } from 'react-router-dom';
import Badge from '../ui/Badge';

/**
 * Placeholder for admin sections with no real backend yet (Investors,
 * Portfolios/Transactions, Reports, and anything downstream of them — see
 * docs: those tags are still "Not yet populated"). Deliberately terse —
 * one glance should tell you this isn't wired up, without a wall of text
 * explaining why every time.
 */
export default function ComingSoon({ title, backTo = '/admin' }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-6">
      <div className="h-14 w-14 rounded-2xl bg-accent-soft text-accent flex items-center justify-center mb-4">
        <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7">
          <path
            d="M12 8v4l2.5 2.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h1 className="text-lg font-semibold text-foreground mb-1.5">{title}</h1>
      <Badge tone="warning" className="mb-4">
        Coming soon
      </Badge>
      <Link to={backTo} className="text-sm text-accent hover:underline">
        ← Back to overview
      </Link>
    </div>
  );
}
